import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

interface Auth0RegisterUserProps {
  redirectUri: string;
}

const Auth0RegisterUserButton: React.FC<Auth0RegisterUserProps> = (props: Auth0RegisterUserProps) => {
  const { loginWithRedirect } = useAuth0();

  const domain = process.env.REACT_APP_DOMAIN;

  function registerUserHandler(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
    loginWithRedirect({
      authorizationParams: {
        'screen_hint': 'signup',
        'redirect_uri': `${domain+props.redirectUri}`
      }
    });
  }

  return (
    <button onClick={registerUserHandler} className={'text-base lg:text-2xl font-semibold rounded-full px-6 py-2 lg:py-3 bg-white/60 border lg:border-2 border-white/30 ring-white/30 shadow-md lg:shadow-lg shadow-slate-900/80 hover:ring-1 hover:bg-sky-300/60'}>
      <label className='cursor-pointer drop-shadow-[0_1.5px_1.5px_rgba(0,0,0,0.5)]'>CADASTRE-SE</label>
    </button>
  );
};

export default Auth0RegisterUserButton;